import axios from "axios";
import { useEffect, useState } from "react";
import MainLayout from "src/components/MainLayout";
import { AppConfig } from "src/config/AppConfig";
import { useAppDispatch, useAppSelector } from "src/hooks/redux/hooks";
import "../../workers/WorkerCategories.css"
import Swal from "sweetalert2";
import "../../userInfo/Users.css";
import { startLoading, stopLoading } from "src/store/loading/loadingSlice";
import { IWorker, IWorkerRatings } from "src/helper/interfaces";
import moment from "moment-timezone";
import { IServiceOrder } from "src/helper/interfaces";
import Cookies from "js-cookie";
import Select from "react-select";
import permanentAddress from "../../../../assets/img/icons/address-permanent.svg";
import currentAddress from "../../../../assets/img/icons/address-current.svg";
import StarRating from "src/components/layout/StarRating";
import { getWorkerRatings } from "../../workers/Workers";
import { useParams } from "react-router-dom";
import profileIcon from "../../../../assets/img/icons/vecteezy_man-empty-avatar-vector-photo-placeholder-for-social_36594092.jpg";
import { formatCategory, formatDiffrentDate } from "src/utils/normalFuntions";
import { FormattedDate } from "rsuite/esm/CustomProvider";



const getAllWorkers = async (token: string, searchValue: string, category: string[], worker_id?: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/all-workers`, {
      headers: {
         "x-access-token": token
      },
      params: {
         search_value: searchValue,
         pageSize: 20,
         category: category,
         worker_id
      }
   })
};
const getDoorstepOrderById = async (token: string, id: string) => {
   return await axios.get(`${AppConfig.DEV_SERVER}/doorstep-order/${id}`, {
      headers: {
         "x-access-token": token
      }
   })
};


const DoorstepOrderDetailsPage = () => {

   const initialValues: IServiceOrder = {

      _id: "",
      assigned_worker: "",
      billing_details: {
         service_charges: 0,
         convenience_charges: 0,
         tax: 0,
         total_amount: 0,
         additional_working_charges: 0,
         additional_working_mins: 0,

         promo_code: "",                   // Promo code applied (if any)
         promo_percentage: 0,                // Percentage discount from the promo code
         promo_amount: 0,                    // Discount amount from the promo code                          
         additional_convenience_charges: 0,  // Any extra convenience charges added
         additional_service_charges: 0,      // Any extra service charges added
         additional_tax: 0,                  // Extra tax calculated

         yows_comm_inc_gst: 0,
         yows_comm_exc_gst: 0,
         worker_comm: 0,
         gst_on_worker_comm: 0,
         gst_on_yows_comm: 0,
         tcs_amt: 0,

         add_gst_on_worker_comm: 0,
         add_gst_on_yows_comm: 0,
         add_tcs_amt: 0,
         add_worker_comm: 0,
         add_yows_comm_exc_gst: 0,
         add_yows_comm_inc_gst: 0,
      },
      createdAt: "",
      date_time: "",
      end_time: "",
      order_type: "",
      otp: "",
      payment_id: "",
      payment_order_id: "",
      service_category: "",
      service_id: "",
      service_count: 0,
      service_providers: [],
      service_title: "",
      user_id: "",
      unique_id: "",
      serviceDetails: {
         title: "",
         price_per_half_hour: 0,
         price_per_hour: 0,
         service_image: "",
         price: 0,
      },
      start_time: "",
      status: "",
      unique_code: "",
      updatedAt: "",
      sub_type: [],
      userDetails: {
         name: "",
         phone: "",
         profile_pic: "",

      },
      workerDetails: {
         name: "",
         phone: "",
         profile_pic: "",
         worker_type: "",
         is_verified: false
      },
      address: {
         street: "",
         country: "",
         state: "",
         city: "",
         lat: 0,
         long: 0,
         pin_code: "",

      },
      __v: 0,
      payment_status: false,
      promo_code: ""
   };

   const { id } = useParams();
   const [selectedWorker, setSelectedWorker] = useState<IWorker | any>();
   const [selectedOrder, setSelectedOrder] = useState(initialValues);
   const [workers, setWorkers] = useState<IWorker[]>([]);
   const [categoryVal, setCategoryVal] = useState<string | string[]>([]);
   const dispatch = useAppDispatch();
   const loading = useAppSelector(state => state.loading.value);
   const Token = Cookies.get('token');
   const [userRating, setUserRating] = useState<IWorkerRatings[]>([]);



   useEffect(() => {

      if (Token) {
         dispatch(startLoading());
         let catValue: string[] = [];
         getDoorstepOrderById(Token as string, id as string).then((res) => {
            // console.log(res?.data?.data)
            if (res?.data?.status_code === 200) {

               setSelectedOrder(res?.data?.data);

               if (res?.data?.data?.order_type === "professional_worker") {
                  // const splitValue = selectedOrder.sub_type.join(",");
                  if (res?.data?.data?.service_category === "Architect") {
                     catValue = [res?.data?.data?.service_category?.toLocaleLowerCase()];
                     setCategoryVal(catValue);
                  }
                     // else if ()
                  else {
                     catValue = res?.data?.data.sub_type;
                     setCategoryVal(catValue);
                  }

               }
               else {
                  // const splitValue = res?.data?.data.service_providers.join(",");
                  catValue = res?.data?.data.service_providers
                  setCategoryVal(catValue);
                  // console.log(splitValue)
               }

               // console.log("catValue: ",)
               getAllWorkers(Token, "", catValue, res?.data?.data?.assigned_worker).then((res) => {
                  // console.log(res?.data?.data?.data);
                  if (res?.data?.status_code === 200) {
                     // console.log("workerss: ", res?.data?.data?.data)
                     setWorkers(res?.data?.data?.data)
                  }
               })
                  .catch((err: any) => {
                     console.log(err);
                     throw err;
                  });

               // this is for getting Ratings 

               const params = {
                  token: Token,
                  id: id as string,
                  pageNo: 1,
                  pageSize: 10,
                  type: "doorstep_order",
               };
               getWorkerRatings(params).then((res) => {
                  // console.log(res?.data);
                  if (res?.data?.status_code === 200) {
                     // console.log(res?.data)
                     // console.log("Ratings: ", res?.data?.data)
                     setUserRating(res?.data?.data?.results);
                     // setTotalPages(res?.data?.data?.totalPages)
                  }
               })
                  .catch((err: any) => {
                     console.log(err);
                     throw err;
                  })


            }
         })
            .catch((err: any) => {
               console.log(err)
               throw err;
            }).finally(() => {
               dispatch(stopLoading());
            })

      }
   }, [id])

   const handleDropdownChange = async (worker: any) => {
      // setSelectedValue(event.target.value);
      setSelectedWorker(worker);
      dispatch(startLoading());

      // console.log(worker)
      try {
         await axios.put(`${AppConfig.DEV_SERVER}/assign/doorstep-order/${selectedOrder?._id}`, { worker_id: worker?.value }, {

            headers: {
               'content-type': 'application/json',
               "X-Access-Token": Token
            },

         }).then((res) => {
            // console.log("res: ", res?.data)
            if (res?.data?.status_code === 200) {
               setTimeout(() => {
                  getAllWorkers(Token as string, "", categoryVal as string[] as any, selectedOrder?.assigned_worker).then((res) => {
                     // console.log(res?.data?.data?.data);
                     if (res?.data?.status_code === 200) {
                        // console.log("workerss: ", res?.data?.data?.data)
                        setWorkers(res?.data?.data?.data)
                     }
                  })
                     .catch((err: any) => {
                        console.log(err);
                        throw err;
                     });
                  dispatch(stopLoading());
                  // setModalShow(false);
                  Swal.fire({
                     position: "center",
                     icon: "success",
                     text: `${res?.data?.msg}`,
                     title: "Success",
                     showConfirmButton: false,
                     timer: 2500
                  }).then(() => window.location.reload())
               }, 1000 * 2)
            } else {
               dispatch(stopLoading());
               Swal.fire({
                  position: "center",
                  icon: "error",
                  text: `${res?.data?.msg}`,
                  showConfirmButton: false,
                  timer: 3000
               });
               setSelectedWorker("")
            }
         })

         // console.log('Response data:', response.data);
      } catch (error: any) {
         console.error('Error making POST request:', error.response ? error.response.data : error.message);
      }
   }


   const isDate = moment(selectedOrder?.createdAt).tz('Asia/Kolkata').format('DD-MM-YYYY hh:mm A');

   let orderType = "";
   if (selectedOrder?.order_type === "normal_worker") {
      orderType = "Doorstep Order"
   }
   else if (selectedOrder?.order_type === "professional_worker") {
      orderType = "Professional Order"
   }

   return (
      <MainLayout showAllFilters={true}>
         <div className="main-div">

            <div className="category-main me-2 p-3 p-md-4"  >
               <div className="row">

                  <div className="col-xxl-3 col-xl-4 p-2 theiaStickySidebar">

                     <div className="theiaStickySidebar"
                        style={{ paddingTop: " 0px", paddingBottom: "1px", position: "static", transform: 'none', top: "0px", left: "276px" }}>
                        <div className="card border-white ">
                           <div className="card-header border-1 " style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <div className="d-flex align-items-center flex-wrap row-gap-3">
                                 <div className="d-flex align-items-center justify-content-center avatar avatar-xxl border border-dashed me-2 flex-shrink-0 text-dark frames">
                                    <img
                                       src={
                                          selectedOrder?.serviceDetails?.service_image
                                             ? typeof selectedOrder?.serviceDetails?.service_image === 'string'
                                                ? selectedOrder?.serviceDetails?.service_image
                                                : URL.createObjectURL(selectedOrder?.serviceDetails?.service_image)
                                             : profileIcon
                                       }

                                    />
                                 </div>
                                 <div className="d-flex flex-column">
                                    <h5 className="mb-1 text-start">{orderType ?? "NA"} </h5>
                                    <span className="text-start  mb-1">{selectedOrder?.unique_id ?? "NA"}</span>
                                    <span className="text-start">Created At: {isDate ?? "NA"} </span>
                                 </div>
                              </div>
                           </div>
                           <div className="card-body text-start">
                              <h5 className="mb-3">Billing Details</h5>
                              <dl className="row mb-0">
                                 {/* Worker Type */}
                                 <dt className="col-7 fw-medium text-dark mb-3">Service Charges</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.service_charges ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3">Service Count</dt>
                                 <dd className="col-5 mb-3">  {selectedOrder?.service_count ?? 0}</dd>
                                 {
                                    selectedOrder?.promo_code?.length ?
                                       <>
                                          <dt className="col-7 fw-medium text-dark mb-3">Promo Code</dt>
                                          <dd className="col-5 mb-3"> {selectedOrder?.billing_details?.promo_code ?? ""}</dd>
                                          {/* <dt className="col-7 fw-medium text-dark mb-3">Promo Percentage </dt>
                                          <dd className="col-5 mb-3"> {selectedOrder?.billing_details?.promo_percentage ?? 0}%</dd> */}
                                          <dt className="col-7 fw-medium text-dark mb-3">Discounted Amount </dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.promo_amount ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Sub Total </dt>
                                          <dd className="col-5 mb-3">
                                             &#8377; {
                                                (selectedOrder?.billing_details?.service_charges * selectedOrder?.service_count) -
                                                (selectedOrder?.billing_details?.promo_amount ? selectedOrder?.billing_details?.promo_amount : 0)}
                                          </dd>
                                       </> : ''

                                 }
                                 <dt className="col-7 fw-medium text-dark mb-3">Tax Amount (GST)</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.tax ?? 0}</dd>


                                 <dt className="col-7 fw-medium text-dark mb-3">Paid Amount</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.total_amount ?? 0}</dd>

                                 {
                                    selectedOrder?.billing_details?.additional_working_mins ?
                                       <>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Mins</dt>
                                          <dd className="col-5 mb-3">  {selectedOrder?.billing_details?.additional_working_mins ?? 0} m</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Service Charges</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.additional_service_charges ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Tax Amount</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.additional_tax ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Amount </dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.additional_working_charges ?? 0}</dd>

                                       </> : ""
                                 }



                                 {/* Yows commision Details */}
                                 <span className="font-weight-normal mb-2">
                                    Yows Commision Details
                                 </span>
                                 <dt className="col-7 fw-medium text-dark mb-3"> Commision (Inc. GST)</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.yows_comm_inc_gst?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3"> Commision (Exc. GST)</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.yows_comm_exc_gst?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3">GST Amount </dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.gst_on_yows_comm?.toFixed(2) ?? 0}</dd>
                                 {
                                    selectedOrder?.billing_details?.additional_working_mins ?
                                       <>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Commision (Inc. GST)</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_yows_comm_inc_gst?.toFixed(2) ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Commision (Exc. GST)</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_yows_comm_exc_gst?.toFixed(2) ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional GST Amount </dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_gst_on_yows_comm?.toFixed(2) ?? 0}</dd>
                                       </> : ""
                                 }
                                 {/* worker commision details */}
                                 <span className="font-weight-normal mb-2">
                                    Worker Commision Details
                                 </span>
                                 <dt className="col-7 fw-medium text-dark mb-3"> Commision (Inc. GST)</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.worker_comm_inc_gst?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3"> Commision (Exc. GST)</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.worker_comm_exc_gst?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3">GST TCS</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.tcs_amt?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3">Final Commission</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.worker_comm?.toFixed(2) ?? 0}</dd>
                                 <dt className="col-7 fw-medium text-dark mb-3">GST Amount</dt>
                                 <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.gst_on_worker_comm?.toFixed(2) ?? 0}</dd>


                                 {
                                    selectedOrder?.billing_details?.additional_working_mins ?
                                       <>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional Commision (Inc. GST)</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_worker_comm?.toFixed(2) ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional GST Amount</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_gst_on_worker_comm?.toFixed(2) ?? 0}</dd>
                                          <dt className="col-7 fw-medium text-dark mb-3">Additional GST TCS</dt>
                                          <dd className="col-5 mb-3"> &#8377; {selectedOrder?.billing_details?.add_tcs_amt?.toFixed(2) ?? 0}</dd>

                                       </> : ""
                                 }
                              </dl>

                           </div>
                        </div>

                        <div className="card border-white">
                           <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                              <h5 className="mb-0 text-start">Address</h5>
                           </div>

                           <div className="card-body">
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={currentAddress} alt="currentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Order Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedOrder?.address?.street || selectedOrder?.address?.pin_code || selectedOrder?.address?.city || selectedOrder?.address?.country ?
                                          `${selectedOrder?.address?.street ? (selectedOrder?.address?.street + ",") : ""} ${selectedOrder?.address?.pin_code || "NA"}, ${selectedOrder?.address?.city || "NA"}, ${selectedOrder?.address?.country || "NA"}`
                                          : "NA"
                                       }
                                    </p>


                                 </div>
                              </div>
                              <div className="d-flex align-items-center mb-3">
                                 <span className="avatar avatar-md rounded me-2 flex-shrink-0 text-default" style={{ background: "#F8FAFC" }}>

                                    <img src={permanentAddress} alt="permanentAddress" />

                                 </span>
                                 <div className="text-start">
                                    <span className="text-dark font-weight-bold">
                                       Permanent Address
                                    </span>
                                    <p className="mb-0 text-start">
                                       {selectedOrder?.address?.street || selectedOrder?.address?.pin_code || selectedOrder?.address?.city || selectedOrder?.address?.country ?
                                          `${selectedOrder?.address?.street ? (selectedOrder?.address?.street + ",") : ""} ${selectedOrder?.address?.pin_code || "NA"}, ${selectedOrder?.address?.city || "NA"}, ${selectedOrder?.address?.country || "NA"}`
                                          : "NA"
                                       }
                                    </p>
                                 </div>
                              </div>
                           </div>
                        </div>

                     </div>
                  </div>
                  <div className="col-xxl-9 col-xl-8 p-2">
                     <div className="row ">
                        <div className="col-md-12 p-2">
                           <div className="card mb-0">
                              <div className="card-header" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                 <h5 className="text-start mb-0" >
                                    Order Details
                                 </h5>
                              </div>
                              <div className="card-body">
                                 <div className="border rounded p-3 pb-0">
                                    <div className="row">
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Order Id</p>
                                             <p className="text-start ">{selectedOrder?._id ? selectedOrder?._id : "NA"} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Service Title</p>
                                             <p className="text-start ">{selectedOrder?.serviceDetails?.title ? selectedOrder?.serviceDetails?.title : "NA"} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Service Count</p>
                                             <p className="text-start ">{selectedOrder?.service_count ? selectedOrder?.service_count : "NA"} </p>
                                          </div>
                                       </div>
                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Service Providers</p>
                                             <p className="text-start ">{selectedOrder?.service_providers?.length ? selectedOrder?.service_providers?.join(", ") : selectedOrder?.sub_type?.length ? selectedOrder?.sub_type : selectedOrder?.service_category} </p>
                                          </div>
                                       </div>
                                       {
                                          selectedOrder?.service_category !== "Architect" ?
                                             <div className="col-sm-6 col-lg-4">
                                                <div className="mb-3 ">
                                                   <p className="text-dark text-start font-weight-normal mb-1">Hourly Service Price </p>
                                                   <p className="text-start ">{selectedOrder?.serviceDetails?.price_per_hour ?? "NA"} </p>
                                                </div>
                                             </div> : ""
                                       }

                                       {
                                          selectedOrder?.order_type === "normal_worker" ?
                                             <div className="col-sm-6 col-lg-4">
                                                <div className="mb-3 ">
                                                   <p className="text-dark text-start font-weight-normal mb-1">Half Hourly Service Price</p>
                                                   <p className="text-start ">{selectedOrder?.serviceDetails?.price_per_half_hour ?? "NA"} </p>
                                                </div>
                                             </div> : ""
                                       }


                                       <div className="col-sm-6 col-lg-4">
                                          <div className="mb-3 ">
                                             <p className="text-dark text-start font-weight-normal mb-1">Order Status </p>
                                             <p className={`text-start font-weight-normal ${selectedOrder?.status === "pending" ? "text-danger" : selectedOrder?.status === "completed" ? "text-success" : "text-warning"}`}>{selectedOrder?.status ? formatCategory(selectedOrder?.status as string) : "NA"} </p>
                                          </div>
                                       </div>
                                       {
                                          selectedOrder?.start_time || selectedOrder?.end_time ?
                                             <>
                                                <div className="col-sm-6 col-lg-4">
                                                   <div className="mb-3 ">
                                                      <p className="text-dark text-start font-weight-normal mb-1">Start Date & Time </p>
                                                      <p className="text-start ">{`${formatDiffrentDate(selectedOrder?.start_time)?.formattedDate}, ${formatDiffrentDate(selectedOrder?.start_time)?.formattedHours}`} </p>
                                                   </div>
                                                </div>
                                                <div className="col-sm-6 col-lg-4">
                                                   <div className="mb-3 ">
                                                      <p className="text-dark text-start font-weight-normal mb-1">End Date & Time </p>
                                                      <p className="text-start ">
                                                         {selectedOrder?.end_time ? `${formatDiffrentDate(selectedOrder?.end_time)?.formattedDate}, ${formatDiffrentDate(selectedOrder?.end_time)?.formattedHours}` : "NA"}
                                                      </p>

                                                   </div>
                                                </div>
                                             </> : ""
                                       }

                                       {
                                          selectedOrder?.status === "assigned" || selectedOrder?.status === "pending" ?
                                             <div className="col-sm-8 ">
                                                <div className="d-flex flex-column gap-2 pt-2 mb-3">
                                                   <span className="text-start">Assign New Worker :</span>
                                                   <div className="d-flex">
                                                      <div className="d-flex align-items-center w-80 w-xl-60">
                                                         <Select
                                                            name="sub_worker_type"
                                                            className="type-selecter w-100 w-xl-80"

                                                            value={selectedWorker as any}
                                                            onChange={handleDropdownChange}
                                                            options={workers?.map((worker: IWorker) => ({
                                                               label: `${worker?.name} - ${worker?.phone}`,
                                                               value: worker?._id, // Set the id as value

                                                            }))}
                                                            isSearchable={true} // Enable search functionality
                                                            required
                                                         />
                                                      </div>
                                                      {
                                                         loading ?
                                                            <div className="w-20 d-flex align-items-center">
                                                               <svg viewBox="25 25 50 50" className="loader-svg w-40">
                                                                  <circle r="20" cy="50" cx="50" className="loader-circle"></circle>
                                                               </svg>
                                                            </div> :
                                                            ""
                                                      }

                                                   </div>

                                                </div>
                                             </div>
                                             :
                                             ""
                                       }

                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>

                        <div className="col-lg-6 p-2">
                           <div className="card  mb-0">
                              <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                 <h5 className="mb-0">
                                    User Details and Ratings
                                 </h5>
                              </div>
                              <div className="card-body">
                                 <div className="d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">User ID: </span>
                                    <span className="text-start">{selectedOrder?.user_id ?? "NA"} </span>
                                 </div>
                                 <div className="d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                    <span className="text-start">{selectedOrder?.userDetails?.name ?? "NA"} </span>
                                 </div>
                                 <div className=" d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                    <span className="text-start">
                                       {selectedOrder?.userDetails?.phone ?? "NA"} </span>
                                 </div>


                                 <div className="d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Ratings: </span>
                                    {
                                       userRating?.[0]?.rating ?
                                          <StarRating averageRating={userRating?.[0]?.rating} /> : "NA"
                                    }

                                 </div>
                                 <div className="d-flex p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold">Review: </span>

                                    <span className="text-start">
                                       {userRating?.[0]?.comment ?? "NA"}

                                    </span>
                                 </div>

                              </div>
                           </div>
                        </div>

                        <div className="col-lg-6 p-2">
                           <div className="card  mb-0">
                              <div className="card-header text-start" style={{ borderBottom: "1px solid rgba(0, 0, 0, 0.175)" }}>
                                 <h5 className="mb-0">
                                    Worker Details
                                 </h5>
                              </div>
                              <div className="card-body">
                                 <div className="d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Worker ID: </span>
                                    <span className="text-start">{selectedOrder?.assigned_worker ?? "NA"} </span>
                                 </div>
                                 <div className="d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Name: </span>
                                    <span className="text-start">{selectedOrder?.workerDetails?.name ?? "NA"} </span>
                                 </div>
                                 <div className=" d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Phone: </span>
                                    <span className="text-start">
                                       {selectedOrder?.workerDetails?.phone ?? "NA"} </span>
                                 </div>
                                 <div className=" d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Worker Type: </span>
                                    <span className="text-start">
                                       {formatCategory(selectedOrder?.workerDetails?.worker_type as string) ?? "NA"} </span>
                                 </div>
                                 <div className=" d-flex align-items-center p-2 gap-3">
                                    <span className="text-dark text-start font-weight-bold  ">Is Verified: </span>
                                    <span className="text-start">
                                       {selectedOrder?.workerDetails?.is_verified ? "True" : "False"} </span>
                                 </div>
                              </div>
                           </div>
                        </div>

                     </div>
                  </div>

               </div>
            </div>

         </div>
      </MainLayout>

   )
};
export default DoorstepOrderDetailsPage;